import { render, staticRenderFns } from "./prizesFormDetail.vue?vue&type=template&id=0cb4eb99&scoped=true"
import script from "./prizesFormDetail.vue?vue&type=script&lang=js"
export * from "./prizesFormDetail.vue?vue&type=script&lang=js"
import style0 from "./prizesFormDetail.vue?vue&type=style&index=0&id=0cb4eb99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4eb99",
  null
  
)

export default component.exports